import { DatePickerInput } from '@mantine/dates'
import { IconCalendar } from '@tabler/icons-react'

type DateRangeRowProps = {
  dateFrom: string | null
  dateTo: string | null
  onDateFromChange: (value: string | null) => void
  onDateToChange: (value: string | null) => void
}

export function DateRangeRow({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
}: DateRangeRowProps) {
  const inputClasses =
    'h-8 !min-h-8 rounded-md border border-gray-200 bg-white px-2 text-xs text-gray-700 outline-none focus:border-blue-400'
  const today = new Date()

  return (
    <div className="flex items-center gap-2">
      <span className="text-[11px] font-medium tracking-wide text-gray-500 uppercase">From</span>
      <DatePickerInput
        placeholder="MM/DD/YYYY"
        value={dateFrom}
        onChange={onDateFromChange}
        valueFormat="MM/DD/YYYY"
        size="xs"
        clearable
        maxDate={today}
        rightSectionPointerEvents="none"
        rightSection={<IconCalendar size={14} className="text-gray-400" />}
        classNames={{ input: inputClasses }}
        className="w-32"
        aria-label="Filter from date"
      />
      <span className="text-[11px] font-medium tracking-wide text-gray-500 uppercase">To</span>
      <DatePickerInput
        placeholder="MM/DD/YYYY"
        value={dateTo}
        onChange={onDateToChange}
        valueFormat="MM/DD/YYYY"
        size="xs"
        clearable
        maxDate={today}
        rightSectionPointerEvents="none"
        rightSection={<IconCalendar size={14} className="text-gray-400" />}
        classNames={{ input: inputClasses }}
        className="w-32"
        aria-label="Filter to date"
      />
    </div>
  )
}
